import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid } from "@material-ui/core";

import { ProfileAction } from "../../../components/profile-action/ProfileAction";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: theme.palette.secondary.main,

    "& .headerContent": {
      height: 60,

      [theme.breakpoints.down("xs")]: {
        padding: "0 20px",
      },

      "& .appLogo": {
        display: "flex",
        alignItems: "center",

        "& img": {
          height: 24,
          width: 40,
        },
      },
    },
  },
}));

export const Header = (props: any) => {
  const classes = useStyles(props);

  return (
    <Grid container className={classes.header}>
      <Grid item sm={1} />
      <Grid item sm={10} xs={12}>
        <Box
          display="flex"
          flexWrap="nowrap"
          alignItems="center"
          justifyContent="space-between"
          className="headerContent"
        >
          <Box className="appLogo">
            <img src={process.env.PUBLIC_URL + "/logo_white.svg"} alt="" />
          </Box>
          <ProfileAction />
        </Box>
      </Grid>
      <Grid item sm={1} />
    </Grid>
  );
};
